import { BASE_URL, s3Path } from '../../general/variables';
import { initDefaultSelect2, getUrlParameter, splitable, ellipseText } from '../../general/functions';
import { classifyLabelColor, generateUniversityBudget } from './function';

const currencyEl = `
  <div class="col-12 duplicate-packages">
    <label class="col-form-label text-right font-weight-bolder">Package Price<span class="text-danger">*</span></label>
    <div class="form-group input-group mb-5">
      <div class="input-group-prepend w-80px">
        <select name="packageCurrency[]" class="form-control selectpicker" data-size="7" data-live-search="true" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
          <option value="1"> SGD</option>
          <option value="2"> AUD</option>
          <option value="3"> USD</option>
          <option value="5"> NZD</option>
          <option value="6"> MYR</option>
          <option value="7"> GBP</option>
          <option value="8"> CAD</option>
          <option value="9"> CHF</option>
          <option value="10"> IDR</option>
          <option value="11"> IEP</option>
          <option value="12"> FRF</option>
          <option value="13"> ITL</option>
          <option value="14"> BEF</option>
          <option value="15"> PTA</option>
          <option value="16"> CNY</option>
          <option value="18"> FT</option>
          <option value="20"> DEM</option>
          <option value="21"> NLG</option>
          <option value="22"> KRW</option>
          <option value="23"> JPY</option>
          <option value="24"> THB</option>
          <option value="25"> SEK</option>
          <option value="26"> TRY</option>
          <option value="45"> AED</option>
          <option value="47"> INR</option>
        </select>
      </div>
      <input type="text" class="form-control package-prices" name="packagePrice[]" aria-describedby="depositAddOns" />
      <button type="button" class="btn btn-light-danger font-weight-bold ml-4 btn-delete-packages">X</button>
    </div>
  </div>
`;
const initScriptEvents = () => {
  $('#eventDates').daterangepicker(
    {
      buttonClasses: ' btn',
      applyClass: 'btn-primary',
      cancelClass: 'btn-secondary',
      timePicker: true,
      timePickerIncrement: 30,
      locale: { format: 'YYYY/MM/DD h:mm A' },
    },
    function (start, end, label) {
      $('#eventDates .form-control').val(`${start.format('YYYY/MM/DD h:mm A')} / ${end.format('YYYY/MM/DD h:mm A')}`);
    }
  );

  $('#itineraryReminderDates').daterangepicker(
    {
      buttonClasses: ' btn',
      applyClass: 'btn-primary',
      cancelClass: 'btn-secondary',
      locale: { format: 'YYYY/MM/DD' },
    },
    function (start, end, label) {
      $('#itineraryReminderDates .form-control').val(`${start.format('YYYY/MM/DD')} / ${end.format('YYYY/MM/DD')}`);
    }
  );

  $('#input_date_tanggal_penggunaan').datetimepicker({
    format: 'DD-MM-YYYY',
    locale: 'id',
  });

  $('#filter_banner, #filter_brochure').select2({
    placeholder: $(this).data('placeholder'),
    minimumResultsForSearch: Infinity,
    width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
    data: [
      {
        id: 'all',
        text: 'All',
      },
      {
        id: 'DELIVERED',
        text: 'Delivered to our Office',
      },
      {
        id: 'PRINT',
        text: 'Print by ICAN Education',
      },
      {
        id: 'INSTITUTION',
        text: 'Brought by Institution team',
      },
    ],
  });

  $('#filter_visitorvisa').select2({
    placeholder: $(this).data('placeholder'),
    minimumResultsForSearch: Infinity,
    width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
    data: [
      {
        id: 'all',
        text: 'All',
      },
      {
        id: 'YES',
        text: 'Yes',
      },
      {
        id: 'NO',
        text: 'No',
      },
    ],
  });

  if ($('#bcp_name').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getEmployees`,
        data: { optional: 'id-text-same', is_group: true },
      },
      '#bcp_name',
      undefined,
      $(this).data('placeholder'),
      true
    );
  }

  if ($('#bcp_branch').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getBranchMaster`,
        data: { optional: 'id-text-same' },
      },
      '#bcp_branch',
      undefined,
      $(this).data('placeholder'),
      true
    );
  }

  if ($('#eventPic').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getEmployees`,
        // 'data': { 'division_key': 'd0f4c4ca5e' }
        data: { is_group: true },
      },
      '#eventPic',
      undefined,
      $(this).data('placeholder'),
      true
    );
  }

  $(document)
    .on('mouseenter', '.togglePopover', function () {
      $(this).popover({ container: 'body' }).popover('show');
    })
    .on('mouseleave', '.togglePopover', function () {
      $(this).popover('hide');
    });
};

const $lpRepeater = $('.landing-page-list').repeater({
  initEmpty: false,
  isFirstItemUndeletable: true,
  show: function (el) {
    $(this).slideDown();

    // Set form input jadi disabled kalau misalnya data dari API
    let curValue = $(this).find('.lp-name-parent').children('.lp-ID');
    let curSibling = $(this).find('.lp-name-parent').children('.lp-name');

    if (curValue.val() != '') {
      curSibling.attr('readonly', true);
    }
  },
  hide: function (delElement) {
    let curValue = $(this).find('.lp-name-parent').children('.lp-ID');

    Swal.fire({
      text: 'Remove Landing Page Entry?',
      icon: 'warning',
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Close',
      customClass: {
        confirmButton: 'btn font-weight-boldest btn-light-danger',
        cancelButton: 'btn font-weight-boldest btn-light-warning',
      },
    }).then((result) => {
      if (result.value) {
        $(this).slideUp(delElement);
      }
    });
  },
});

const $repeater = $('.endorse-list').repeater({
  initEmpty: false,
  isFirstItemUndeletable: true,
  show: function (el) {
    $(this).slideDown();

    // Set form input jadi disabled kalau misalnya data dari API
    let curValue = $(this).find('.kol-name-parent').children('.kol-ID');
    let curSibling = $(this).find('.kol-name-parent').children('.kol-name');

    let curLink = $(this).find('.kol-link');

    if (curLink.val().includes('bit.ly')) {
      curLink.attr('readonly', true);
    } else {
      curLink.attr('readonly', false);
    }

    if (curValue.val() != '') {
      curSibling.attr('readonly', true);
    }
  },
  hide: function (delElement) {
    let curValue = $(this).find('.kol-name-parent').children('.kol-ID');
    Swal.fire({
      text: 'Hapus endorser?',
      icon: 'warning',
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Close',
      customClass: {
        confirmButton: 'btn font-weight-boldest btn-light-danger',
        cancelButton: 'btn font-weight-boldest btn-light-warning',
      },
    }).then((result) => {
      if (result.value) {
        $.post(
          BASE_URL + 'C_Event/deleteEndorseData',
          {
            id: curValue.val(),
            eid: getUrlParameter('id'),
          },
          function (resp) {
            $(this).slideUp(delElement);
          }
        );
      }
    });
  },
});

const formCreateInvoiceEl = document.getElementById('formCreateInvoice');
const createInvoiceValidation = formCreateInvoiceEl
  ? FormValidation.formValidation(document.getElementById('formCreateInvoice'), {
    fields: {
      createInvoiceType: {
        validators: {
          notEmpty: {
            message: 'Type cannot be empty',
          },
        },
      },
      createInvoiceDue: {
        validators: {
          notEmpty: {
            message: 'Due date cannot be empty',
          },
        },
      },
      createInvoiceDetails: {
        validators: {
          notEmpty: {
            message: 'Details cannot be empty',
          },
        },
      },
    },
    plugins: {
      trigger: new FormValidation.plugins.Trigger(),
      bootstrap: new FormValidation.plugins.Bootstrap(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
  : null;

const universityList = $('#universityTable').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'Expo_Packages/getRelatedUniversities?id=' + getUrlParameter('id') + '&type=' + getUrlParameter('type'),
        map: function (raw) {
          $('#totalUniv').html('(' + raw.length + ')');

          var dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          let curCountry = [
            {
              id: 'all',
              text: 'All',
            },
          ];

          let curBudget = [];

          for (let i = 0; i < raw.length; i++) {
            curCountry.push({
              id: raw[i].COUNTRY_ID,
              text: raw[i].COUNTRY_NAME,
              iso: raw[i].COUNTRY_ISO.toLowerCase(),
            });

            /**
             * Cek mata uangnya udah ada atau belom. Kalau belom ada, tammbahin ke dalam array
             */
            const curIndex = curBudget.findIndex((x) => x.currency === raw[i].CURRENCY_NAME);

            const curPrice = parseFloat(raw[i].PACKAGE_PRICE);
            const curDiscount = raw[i].DISCOUNT_PERCENTAGE;
            let finalPrice = 0;

            if (curDiscount == null) {
              finalPrice = curPrice;
            } else {
              finalPrice = curPrice - parseInt(curPrice * (curDiscount / 100));
            }

            if (curIndex === -1) {
              curBudget.push({
                id: raw[i].COUNTRY_ID,
                currency: raw[i].CURRENCY_NAME,
                value: finalPrice,
              });
            } else {
              curBudget[curIndex].value = parseFloat(curBudget[curIndex].value) + parseFloat(finalPrice);
            }
          }

          const ids = curCountry.map(({ id }) => id);
          const filteredCountry = curCountry.filter(({ id }, index) => !ids.includes(id, index + 1));

          $('#countryFilter').select2({
            placeholder: $(this).data('placeholder'),
            minimumResultsForSearch: Infinity,
            width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
            data: filteredCountry,
          });

          const budgetEl = generateUniversityBudget(curBudget);

          $('#budgetContainer').empty();
          $('#budgetContainer').append(budgetEl);

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: false,
    serverFiltering: true,
    serverSorting: false,
  },
  layout: { scroll: false, footer: false },
  search: {
    input: $('#univeritySearch'),
    key: 'generalSearch',
    delay: 500,
  },
  sortable: true,
  pagination: true,
  columns: [
    {
      field: 'UNI_NAME',
      title: 'Information',
      type: 'text',
      sortable: false,
      template: function (row) {
        let additionalDt = [],
          isHasLogos = '',
          curDescription = '',
          itinerariesData = '',
          btnViewPicContacts = '',
          bannerType = '',
          bannerBrochure = '',
          btnBannerUrl = '',
          btnBrochureUrl = '',
          labelDisc = '',
          visitorVisaStatus = '';
        btnViewPicContacts = row.PIC_ID ? `<button data-pic-id="${row.PIC_ID}" data-pic-name="${row.PIC_NAME}" data-pic-email="${row.PIC_EMAIL}" data-pic-phone="${row.PIC_PHONE}" data-itinerary-status="${row.ITINERARY_STATUS}" type="button" class="btnViewPicData btn btn-sm btn-light-dark font-weight-bolder mr-2">View PIC Data</button>` : btnViewPicContacts;
        isHasLogos = row.LOGO_LINK ? `<a href="${row.LOGO_LINK}" target="_blank" class="btn btn-sm btn-primary font-weight-bolder mr-2">View University Logo</a>` : isHasLogos;
        if (row.INSTITUTION_TYPE) {
          curDescription += `<div class="col-3 mb-2"> <span class="font-weight-bolder">Institution Type</span>`;
          if (!splitable(row.INSTITUTION_TYPE, ';')) {
            switch (row.INSTITUTION_TYPE) {
              case 'UNIVERSITY':
                curDescription += `<div class="col-9">: University</div>`;
                break;
              case 'SCHOOLANDPREUNIV':
                curDescription += `<div class="col-9">: High School & College</div>`;
                break;
              case 'TAFE':
                curDescription += `<div class="col-9">: TAFE</div>`;
                break;
            }
          } else {
            let splitType = row.INSTITUTION_TYPE.split(';');
            for (let i = 0; i < row.INSTITUTION_TYPE.length; i++) {
              switch (splitType[i]) {
                case 'UNIVERSITY':
                  curDescription += `University, `;
                  break;
                case 'SCHOOLANDPREUNIV':
                  curDescription += `High School & College, `;
                  break;
                case 'TAFE':
                  curDescription += `TAFE, `;
                  break;
              }
            }
          }
          curDescription += '</div>';
        }
        if (row.VIDEO_LINK) {
          curDescription += `
          <div class="col-3 mb-2"> <span class="font-weight-bolder">Promotion Material</span></div>
          <div class="col-9">: <a href="${row.VIDEO_LINK}" target="_blank">${row.VIDEO_LINK}</a></div>
        `;
        }

        if (row.BANNER_TYPE) {
          if (row.SUBMISSIONS && row.SUBMISSIONS.details.BANNER_TYPE) {
          } else {
            curDescription += `<div class="col-3 mb-2"><span class="font-weight-bolder">Banner and Marketing Kits</span></div>`;
            switch (row.BANNER_TYPE) {
              case 'DELIVERED':
                curDescription += `<div class="col-9">: Delivered to our Office</div>`;
                break;
              case 'PRINT':
                curDescription += `<div class="col-9">: Print by ICAN Education</div>`;
                break;
              case 'INSTITUTION':
                curDescription += `<div class="col-9">: Brought by Institution team</div>`;
                break;
            }
          }
        }

        if (row.CURRENCY_NAME) {
          // Parse Number
          let packagePrice = parseFloat(row.PACKAGE_PRICE),
            packageDisc = row.DISCOUNT_PERCENTAGE ? parseInt(row.DISCOUNT_PERCENTAGE) : '',
            finalNumber = '',
            tempNumberDiscount = 0;

          if (packageDisc && packagePrice != 0) {
            tempNumberDiscount = packagePrice * (packageDisc / 100);
            finalNumber = packagePrice - parseInt(tempNumberDiscount);
            finalNumber = finalNumber.toLocaleString('id-ID');
            labelDisc = `<span class="font-size-sm fw-normal">(Discount ${packageDisc}%)</span>`;
          } else {
            finalNumber = packagePrice.toLocaleString('id-ID');
          }

          // if (Number.isInteger(row.PACKAGE_PRICE)) {
          //   finalNumber = parseInt(row.PACKAGE_PRICE).toLocaleString('id-ID');
          // } else {
          //   finalNumber = parseFloat(row.PACKAGE_PRICE).toFixed(2);
          // }

          curDescription += `<div class="col-3 mb-2"><span class="font-weight-bolder">Price ${labelDisc}</span></div>`;
          curDescription += `<div class="col-9">:<span class="font-weight-bolder"> ${row.CURRENCY_NAME}</span> ${finalNumber}</div>`;
        }

        if (row.SUBMISSIONS) {
          itinerariesData += `<div class="col-12 font-weight-bolder text-uppercase mb-2"><u>Itineraries</u></div>`;
          additionalDt.ONE = `
            <div class="d-flex flex-start">
              <div class="w-75px font-weight-bold">Dinner</div> : ${row.SUBMISSIONS.details.DAYONE_DINNER == 'YES' ? `${row.SUBMISSIONS.details.DAYONE_DINNER_PAX} Pax` : 'No'}
            </div>
            <div class="d-flex flex-start">
              <div class="w-75px font-weight-bold">Transports</div> : ${row.SUBMISSIONS.details.DAYONE_TRANSPORT == 'YES' ? 'Yes' : 'No'}
            </div>
          `;

          if (row.SUBMISSIONS.details.DAYTWO_ATTENDANCE == 'YES') {
            additionalDt.TWO = `
              <div class="d-flex flex-start">
                <div class="w-75px font-weight-bold">Dinner</div> : ${row.SUBMISSIONS.details.DAYTWO_DINNER == 'YES' ? `${row.SUBMISSIONS.details.DAYTWO_DINNER_PAX} Pax` : 'No'}
              </div>
              <div class="d-flex flex-start">
                <div class="w-75px font-weight-bold">Transports</div> : ${row.SUBMISSIONS.details.DAYTWO_TRANSPORT == 'YES' ? 'Yes' : 'No'}
              </div>
            `;
          }
          let colorBanner = classifyLabelColor(row.SUBMISSIONS.details.BANNER),
            colorBrochure = classifyLabelColor(row.SUBMISSIONS.details.BROCHURE),
            colorVisitorVisa = classifyLabelColor(row.SUBMISSIONS.details.VISITOR_VISA);

          btnBannerUrl = row.SUBMISSIONS.details.BANNER_LINK ? `<a href="${row.SUBMISSIONS.details.BANNER_LINK}" target="_blank" class="btn btn-sm btn-light-dark font-weight-bolder mr-2">View Banner Link</a> ` : btnBannerUrl;
          btnBrochureUrl = row.SUBMISSIONS.details.BROCHURE_LINK ? `<a href="${row.SUBMISSIONS.details.BROCHURE_LINK}" target="_blank" class="btn btn-sm btn-light-dark font-weight-bolder mr-2">View Brochure Link</a> ` : btnBrochureUrl;
          bannerType = row.SUBMISSIONS.details.BANNER_TYPE ? `<div class="ml-2 font-weight-bolder">Banner : <span class="label fw-bold label-lg label-inline label-${colorBanner}">${row.SUBMISSIONS.details.BANNER_TYPE}</span></div> ` : '';
          bannerBrochure = row.SUBMISSIONS.details.BROCHURE_TYPE ? `<div class="ml-2 font-weight-bolder">Brochure : <span class="label fw-bold label-lg label-inline label-${colorBrochure}">${row.SUBMISSIONS.details.BROCHURE_TYPE}</span></div> ` : '';
          visitorVisaStatus = row.SUBMISSIONS.details.VISITOR_VISA ? `<div class="ml-2 font-weight-bolder">C11 Visitor Visa : <span class="label fw-bold label-lg label-inline label-${colorVisitorVisa}">${row.SUBMISSIONS.details.VISITOR_VISA}</span></div> ` : '';

          // print PIC itinerary
          $.each(row.SUBMISSIONS.submission_details, function (i, v) {
            if (i <= 1) {
              itinerariesData += `
                <div class="col-6">
                  <ul class="list-unstyled">
                    <li class="mb-2"><span class="font-weight-bolder label label-inline label-primary">Day ${v.DAY == 'TWO' ? '2' : '1'}</span></li>
                    <li class="mb-1 font-weight-bold">${v.PIC_NAME}</li>
                    <li class="mb-1 d-none">${v.PIC_EMAIL}</li>
                    <li class="mb-1 d-none">${v.PIC_PHONE}</li>
                    <li class="mb-1 d-flex flex-column">${v.DAY == 'TWO' ? additionalDt.TWO : additionalDt.ONE}</li>
                  </ul>
                </div>
              `;
            }
          });
        }

        return `
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flex-stack">
              <div></div>
              <div class="d-flex flex-end">
                ${visitorVisaStatus}
                ${bannerType}
                ${bannerBrochure}
              </div>
            </div>
            <div class="separator separator-dashed separator-border-2 separator-light my-4"></div>
          </div>
          <div class="col-md-7">
            <div class="d-flex flex-column">
              <div class="font-weight-bolder font-size-h4 text-primary mb-3" >${row.UNI_NAME} ${row.PROXY == 'YES' ? '(PROXY)' : ''}</div>
              <div class="form-row">${curDescription}</div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-row">
              ${itinerariesData}
            </div>
          </div>
          <div class="col-md-12">
          <div class="separator separator-dashed separator-border-2 separator-light my-4"></div>
            <div class="d-flex flex-end">
              ${btnViewPicContacts}
              <button class="btn btn-sm btn-light-dark mr-2 font-weight-bolder ${row.SUBMISSION_ID == null ? 'd-none' : ''} btn-view-itineraries" data-id="${row.SUBMISSION_ID}">View Itineraries</button>
              ${btnBannerUrl}
              ${btnBrochureUrl}
              ${isHasLogos}
            </div>
          </div>
        </div>
      `;
      },
    },
  ],
});

const invoiceList = $('#invoiceTables').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'C_Event/getNewInvoiceList?id=' + getUrlParameter('id'),
        method: 'POST',
        map: function (raw) {
          var dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: true,
    serverFiltering: true,
    serverSorting: true,
  },
  layout: { scroll: false, footer: false },
  sortable: true,
  pagination: true,
  columns: [
    {
      field: 'DESCRIPTION',
      title: 'Description',
      type: 'text',
      width: 250,
      template: function (row) {
        let curDescription = '';

        if (row.UNI_NAME != null) {
          curDescription += `<label>Request Invoice for <strong>${row.UNI_NAME}</strong></label>`;
          curDescription += '<br/><br/>';
          curDescription += '<label>Detail: </label><br/>';
          curDescription += row.DESCRIPTION;
        } else {
          curDescription += row.DESCRIPTION;
        }

        return curDescription;
      },
    },
    {
      field: 'TYPE',
      title: 'Type',
      type: 'text',
      width: 70,
      template: function (row) {
        let curLabel, curClass, curText;

        if (row.TYPE_EVENT == 'INVOICE') {
          curLabel = 'text-primary';
          curClass = 'label-primary';
          curText = 'Invoice';
        } else {
          curLabel = 'text-danger';
          curClass = 'label-danger';
          curText = 'Expense';
        }

        return `
          <span class="label ${curClass} label-dot mr-2"></span>
          <span class="font-weight-bold ${curLabel}">${curText}</span>
        `;
      },
    },
    {
      field: 'FILE',
      title: 'File',
      type: 'text',
      width: 150,
      template: function (row) {
        let file, formattedFile, approveFile, formattedApprove;
        let formattedPath = '';

        file = row.FILE == null || row.FILE == '' ? null : row.FILE;
        approveFile = row.APPROVE_FILE == null || row.APPROVE_FILE == '' ? null : row.APPROVE_FILE;

        if (file != null) {
          formattedFile = row.FILE.length > 10 ? row.FILE.substring(0, 10) + '...' : row.FILE;
        } else {
          formattedFile = '';
        }

        if (approveFile != null) {
          formattedApprove = row.APPROVE_FILE.length > 10 ? row.APPROVE_FILE.substring(0, 10) + '...' : row.APPROVE_FILE;
        } else {
          formattedApprove = '';
        }

        if (row.TYPE_EVENT == 'EXPENSE') {
          formattedPath = `${s3Path}/Event/Invoice/` + row.SCHEDULE_ID + '/BUKTI';
        } else if (row.TYPE_EVENT == 'INVOICE') {
          formattedPath = `${s3Path}/Events/` + row.SCHEDULE_ID;
        }

        let output = '';

        if (row.FILE && row.FILE.includes('https://')) {
          output += `
          <label>File: </label>
          <span class="font-weight-bolder">
            <a href="${row.FILE}" target="_blank">${formattedFile}</a>
          </span><br/>
        `;
        } else {
          output += `
          <label>File: </label>
          <span class="font-weight-bolder">
              <a href="${`${s3Path}/Events/` + row.SCHEDULE_ID + '/' + encodeURIComponent(row.FILE)}" target="_blank">${formattedFile}</a>
          </span><br/>
        `;
        }

        if (row.APPROVE_FILE && row.APPROVE_FILE.includes('https://')) {
          output += `
          <label>Approve File: </label>
          <span class="font-weight-bolder">
            <a href="${row.APPROVE_FILE}" target="_blank">${formattedApprove}</a>
          </span><br/>
        `;
        } else {
          output += `
          <label>Approve File: </label>
          <span class="font-weight-bolder">
              <a href="${formattedPath + '/' + encodeURIComponent(row.APPROVE_FILE)}" target="_blank">${formattedApprove}</a>
          </span><br/>
        `;
        }

        return output;
      },
    },
    {
      field: 'END_DATE',
      title: 'Due Date',
      type: 'text',
      width: 130,
      template: function (row) {
        const month = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
        let dueDate, formattedDate;

        dueDate = row.END_DATE == null ? null : new Date(row.END_DATE);

        if (dueDate != null) {
          formattedDate = dueDate.getDate() + ' ' + month[dueDate.getMonth()] + ' ' + dueDate.getFullYear();
        } else {
          formattedDate = '-';
        }

        return `<span class="font-weight-bolder">${formattedDate}</span>`;
      },
    },
    {
      field: 'STATUS',
      title: 'Status Payment',
      type: 'text',
      width: 100,
      template: function (row) {
        let curClass, curText;

        if (row.DATE_APPROVE != null) {
          curClass = ' label-light-success ';
          curText = 'Paid';
        } else {
          switch (row.STATUS) {
            case 'PAID':
              curClass = ' label-light-success ';
              curText = 'Paid';
              break;
            case 'UNPAID':
              curClass = ' label-light-danger ';
              curText = 'Unpaid';
              break;
            case 'SEND':
              curClass = ' label-light-primary ';
              curText = 'Send';
              break;
            case 'UNSEND':
              curClass = ' label-light-warning ';
              curText = 'Unsend';
              break;
            case 'CREATE':
            case 'CREATED':
            case 'PENDING':
              curClass = ' label-light-dark ';
              curText = 'PENDING';
              break;
          }
        }

        return `<span class="label font-weight-bold label-lg ${curClass} label-inline">${curText}</span>`;
      },
    },
    {
      field: '',
      title: 'Action',
      type: 'button',
      width: 165,
      textAlign: 'center',
      template: function (row) {
        return `
        <button class="btn btn-light-warning ${row.APPROVE_FILE != null ? 'd-none' : ''} btn-edit-invoice mr-2" data-id="${row.ID}">Edit</button>
        <button class="btn btn-light-danger ${row.APPROVE_FILE != null ? 'd-none' : ''} btn-delete-invoice" data-id="${row.ID}">Delete</button>
      `;
      },
    },
  ],
});

const proposalList = $('#proposalTable').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'C_Event/getProposal?id=' + getUrlParameter('id'),
        map: function (raw) {
          var dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: false,
    serverFiltering: false,
    serverSorting: false,
  },
  layout: { scroll: false, footer: false },
  sortable: true,
  pagination: true,
  columns: [
    {
      field: 'DESCRIPTION',
      title: 'Description',
      type: 'text',
      width: 250,
      template: function (row) {
        let curDescription = '';

        curDescription += row.DESCRIPTION;

        return curDescription;
      },
    },
    {
      field: 'FILE',
      title: 'File',
      type: 'text',
      width: 150,
      template: function (row) {
        let file, formattedFile;
        const isURL = row.FILE.startsWith('http://') || row.FILE.startsWith('https://');

        if (isURL) {
          file = row.FILE.split('/').pop();
          formattedFile = `<a target="_blank" href="${row.FILE}">${ellipseText(file, 10, true)}</a>`;
        } else {
          if (row.FILE) {
            formattedFile = `<a target="_blank" href="${s3Path}/Events/${getUrlParameter('id')}/Proposal/${row.FILE}">${ellipseText(row.FILE, 10, true)}</a>`;
          } else {
            formattedFile = '';
          }
        }

        return `
          <label>File: </label>
          <span class="font-weight-bolder">
            ${formattedFile}
          </span>
        `;
      },
    },
    {
      field: 'STAFF_NAME',
      title: 'Creator',
      type: 'text',
      width: 250,
      template: function (row) {
        let curDescription = '';

        curDescription += row.STAFF_NAME;

        return curDescription;
      },
    },
    {
      field: 'CREATED',
      title: 'Created',
      type: 'text',
      width: 130,
      template: function (row) {
        const month = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
        let dueDate, formattedDate;

        dueDate = row.CREATED == null ? null : new Date(row.CREATED);

        if (dueDate != null) {
          formattedDate = dueDate.getDate() + ' ' + month[dueDate.getMonth()] + ' ' + dueDate.getFullYear();
        } else {
          formattedDate = '-';
        }

        return `<span class="font-weight-bolder">${formattedDate}</span>`;
      },
    },
    {
      field: '',
      title: 'Action',
      type: 'button',
      width: 165,
      textAlign: 'center',
      template: function (row) {
        return `
        <button class="btn btn-light-warning btn-edit-proposal" data-id="${row.ID}">Edit</button>
        <button class="btn btn-light-danger btn-delete-proposal mr-4" data-id="${row.ID}">Delete</button>
      `;
      },
    },
  ],
});

export { currencyEl, initScriptEvents, $lpRepeater, $repeater, createInvoiceValidation, universityList, invoiceList, proposalList };
